import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import { useDevCenterRouter } from '../effects/useDevCenterRouter';

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withReactRouterLocation(Component) {
  function WithReactRouterLocation({ location, history, match, ...otherProps }) {
    const locationWithQuery = {
      ...location,
      query: queryString.parse(location.search),
    };
    return <Component location={locationWithQuery} {...otherProps} />;
  }

  WithReactRouterLocation.displayName = `withReactRouterLocation(${getDisplayName(Component)})`;

  return withRouter(WithReactRouterLocation);
}

export function withUniversalLocationHOC(Component) {
  const ComponentWithReactRouterLocation = withReactRouterLocation(Component);

  function WithUniversalLocation(props) {
    const devCenterRouter = useDevCenterRouter();

    if (devCenterRouter) {
      return <Component {...props} location={devCenterRouter.location} />;
    }

    return <ComponentWithReactRouterLocation {...props} />;
  }

  WithUniversalLocation.displayName = `WithUniversalLocationHOC(${getDisplayName(Component)})`;

  return WithUniversalLocation;
}
